import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import { Subject } from 'rxjs';
import { EmailAutocomplete } from '@models/models';

@Component({
	selector: 'email-multiselect',
	template: require('./email-multiselect.component.html')
})
export class EmailMultiselectComponent implements OnInit, OnChanges {
	@Input() disabled: boolean;
	@Input() loading: boolean;
	@Input() autocomplete: Subject<string>;
	@Input() autocompleteValues: Array<EmailAutocomplete> = [];
	@Input() placeholder: string;
	@Input() value: Array<EmailAutocomplete> = [];
	@Input() customClass: string;
	@Input() maxAllowedAmount: number;
	@Output() valueChanges: EventEmitter<Array<string>> = new EventEmitter();
	peopleLoading = false;
	selectedValues: Array<EmailAutocomplete> = [];

	constructor() {}

	ngOnInit(): void {
		if (this.value) {
			this.selectedValues = [...this.value];
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.value && changes.value.currentValue) {
			this.selectedValues = [...this.value];
		}
	}

	emitSelectChange(ev: Array<string>): void {
		this.valueChanges.emit(ev);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/email-multiselect/email-multiselect.component.ts